module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgcenter"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "img9",
      "src": "images/img9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("On horseback in Mexico, leading the hunt for the revolutionary leader Pancho Villa, Pershing leads his command across a river. 3US")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("President Wilson named Pershing as commander-in-chief, a post he retained for the duration. Pershing, who was a major general, was promoted to full general in the National Army, and was made responsible for the organization, training, and supply of a combined professional and draft Army and National Guard force that eventually grew from 27,000 inexperienced men to two Armies totalling over two million soldiers.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb16a2fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01g_AMERICAN_EXPEDITIONARY_FORCE.vue
// module id = 90
// module chunks = 0